class ZoomHandler {
	constructor(size_x, watcher) {
		this.size_x = size_x;
		// El watcher le avisa a react que actualice su state con el nuevo zoom
		this.watcher = watcher;
	}

	getMaxZoom() {
		const anchoWindow = $(window).width();
		const gameAncho = this.size_x + 60;

		return (anchoWindow / gameAncho).toFixed(2);
	}

	// Tamaño de cada paso de zoom que se de
	getStepsWidth() {
		return (this.getMaxZoom() - 1) / 10;
	}

	// Cambia el zoom del gamescreen y avisa a quien corresponda
	setZoom(zoom, from = "buttons") {
		if (this.getMaxZoom() < zoom) {
			// eslint-disable-next-line no-param-reassign
			zoom = this.getMaxZoom();
		}
		if (zoom < 1) {
			// eslint-disable-next-line no-param-reassign
			zoom = 1;
		}
		const { gameInfo } = gameSettings;

		const gameAncho = gameInfo.size_x;
		const $GameScreen = $(".GameScreen");
		const $gameContainer = $("#gameContainer");
		const originalWidth =			$GameScreen.attr("data-width") || parseInt($GameScreen.css("width"), 10);
		const originalMargin =			$GameScreen.attr("data-marginleft")
			|| parseInt($GameScreen.css("margin-left"), 10);
		$GameScreen.attr("data-width", originalWidth);
		$GameScreen.attr("data-marginLeft", originalMargin);
		const isLateralRightActive =			$(".GameScreen-GameBox-related--derecha--vertical").length > 0;
		const propsGameScreen = {};

		// El nuevo ancho sera, el ancho del juego * zoom más 1 o 2 paneles laterales,
		// Esto lo determinamos viendo si los relacionados de la derecha tienen la clase vertical
		// la cual es asignada en objectsResize
		propsGameScreen.width =			gameAncho * zoom + (isLateralRightActive ? 2 : 1) * (150 + 32);

		// Calculamos el margen de la izquierda
		propsGameScreen["margin-left"] =			originalMargin - (propsGameScreen.width - originalWidth) / 2;
		// Hacemos este max para que no se vaya a salir de la pantalla
		propsGameScreen["margin-left"] = Math.max(
			propsGameScreen["margin-left"],
			0,
		);

		$gameContainer.css("zoom", zoom);

		$GameScreen.css(propsGameScreen);

		$(".Main,.Footer").css("width", propsGameScreen.width);
		$(".Banners-lateral--derecha").css({
			left: $(".GameScreen").offset().left + propsGameScreen.width + 20,
			right: "auto",
		});
		// Callback segun corresponda
		if (from !== "slider") {
			$(".zoomHandler").slider("option", "value", zoom);
		} else {
			this.watcher(zoom);
		}
		return zoom;
	}

	initSlider() {
		const esto = this;
		if (typeof $ === "undefined") {
			return;
		}
		$(".zoomHandler").slider({
			min: 1,
			max: this.getMaxZoom(),
			step: this.getStepsWidth(),

			change(event, ui) {
				const valor = ui.value;
				esto.setZoom(valor, "slider");
			},
		});
	}
}
export default ZoomHandler;
